<!-- <app-header *ngIf="isLoggedIn$ | async as isLoggedIn"></app-header> -->
<router-outlet></router-outlet>
<!-- <app-header #header></app-header> -->
<!-- <app-footer *ngIf="isLoggedIn$ | async as isLoggedIn"></app-footer> -->
